/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var WishlistServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Wishlist: function () {
            return function (headers) {
                var service = {
                    addToWishlist: function (addToWishlistRequest) {
                        return httpClient.invoke('POST', '/v1/wishlists/my', addToWishlistRequest, headers);
                    },
                    getWishlist: function (getWishlistRequest) { return httpClient.invoke('POST', '/v1/wishlists/my/get', getWishlistRequest, headers); },
                    getWishlistById: function (getWishlistByIdRequest) {
                        return httpClient.invoke('POST', '/v1/wishlists/get', getWishlistByIdRequest, headers);
                    },
                    getWishlists: function (getWishlistsRequest) { return httpClient.invoke('GET', '/v1/wishlists', getWishlistsRequest, headers); },
                    removeFromWishlist: function (removeFromWishlistRequest) {
                        return httpClient.invoke('POST', '/v1/wishlists/my/removeItems', removeFromWishlistRequest, headers);
                    },
                };
                service.addToWishlist.__http_method = 'POST';
                service.addToWishlist.__http_url = '/v1/wishlists/my';
                service.getWishlist.__http_method = 'POST';
                service.getWishlist.__http_url = '/v1/wishlists/my/get';
                service.getWishlistById.__http_method = 'POST';
                service.getWishlistById.__http_url = '/v1/wishlists/get';
                service.getWishlists.__http_method = 'GET';
                service.getWishlists.__http_url = '/v1/wishlists';
                service.removeFromWishlist.__http_method = 'POST';
                service.removeFromWishlist.__http_url = '/v1/wishlists/my/removeItems';
                return service;
            };
        },
    };
};
exports.WishlistServer = WishlistServer;
exports.WishlistServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map